import React, { useState, useEffect } from 'react';
import { Descriptions, Button, Modal, Input, Popconfirm, message, Table, Select, Card, Upload } from 'antd';
import '../css/ArticleActionsDetail.css';
import ArticleModal from 'views/articles/components/ArticleModal';
import { cartableAction } from 'api/cartableservice';
import { useNavigate } from 'react-router-dom';
import { getReviewerList, sendToReview } from 'api/journalservice';
import { getArticleStepReviewer, DeleteArticleReviewer } from 'api/articleservice';
import { DeleteOutlined, CheckOutlined, QuestionCircleOutlined, LoadingOutlined, ClockCircleOutlined, EllipsisOutlined, UploadOutlined, FilePdfOutlined, CloseOutlined } from '@ant-design/icons';
import { getIssuesList } from 'api/journalservice';
import PdfUploader from 'components/pdfuploader/PdfUploader';
import { Center } from '@chakra-ui/react';
import { Tooltip } from 'antd';

const ArticleActionsDetail = ({ data, cartableRef }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [description, setDescription] = useState('');
  const [loadingActions, setLoadingActions] = useState({}); // برای لودینگ دکمه‌ها
  const [reviewers, setReviewers] = useState([]);
  const [selectedReviewers, setSelectedReviewers] = useState([]);
  const [reviewersLoading, setReviewersLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [refreshTable, setRefreshTable] = useState(false);
  const [modalParams, setModalParams] = useState({ title: '', contentId: null });
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();
  const { TextArea } = Input;
  const { Option } = Select;

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const years = [currentYear + 1, ...Array.from({ length: 4 }, (_, i) => currentYear - i)];

  const [issuesList, setIssuesList] = useState([]);
  const [IssuesLoading, setIssuesLoading] = useState(false);

  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleViewFile = () => {

    const base64String = data.publishedPDFFile;

    // تبدیل base64 به Blob
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // ساخت URL موقت برای نمایش در پنجره جدید
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');

  };

  // const beforeUpload = (file) => {
  //   const isPdf = file.type === 'application/pdf';
  //   if (!isPdf) {
  //     message.error('You can only upload PDF files!');
  //   }

  //   const isLt50MB = file.size / 1024 / 1024 < 50;
  //   if (!isLt50MB) {
  //     message.error('File must be smaller than 50MB!');
  //   }

  //   return isPdf && isLt50MB;
  // };

  // const customRequest = ({ file, onSuccess }) => {
  //   setFileList([file]); // فقط یه فایل نگه می‌داریم
  //   onSuccess("ok");
  // };

  // const handleUpload = async () => {
  //   if (fileList.length === 0) {
  //     message.warning("Please select a file first.");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append('file', fileList[0]); // فقط یه فایل می‌گیریم
  //   formData.append('articleId', data.articleId); // در صورت نیاز

  //   setUploading(true);

  //   try {
  //     // API here
  //     const response = await fetch('/api/upload-proof-pdf', {
  //       method: 'POST',
  //       body: formData,
  //     });

  //     if (!response.ok) throw new Error('Upload failed');

  //     message.success("File uploaded successfully");
  //     setFileList([]);
  //   } catch (error) {
  //     console.error(error);
  //     message.error("Failed to upload file");
  //   } finally {
  //     setUploading(false);
  //   }
  // };


  // نمایش مودال
  const showModal = (params) => {
    setModalParams(params);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleDescriptionChange = (e) => setDescription(e.target.value);

  const checkData = (value) => (value ? value : "No Data");

  // محدودیت انتخاب داور (حداکثر 3)
  const handleReviewerChange = (value) => {
    if (value.length > 3) {
      message.warning("You can select up to 3 reviewers.");
      return;
    }
    setSelectedReviewers(value);
  };

  // حذف داور
  const handleDelete = async (record) => {
    try {
      await DeleteArticleReviewer(record?.articleId, record?.reviewerId);
      message.success("Reviewer Deleted Successfully");
      setRefreshTable(prev => !prev);
    } catch (err) {
      message.error("Error deleting reviewer");
      console.error(err);
    }
  };

  // ارسال به داوران
  const handleSendToReview = async () => {
    if (selectedReviewers.length === 0) {
      message.warning("Please select at least one reviewer.");
      return;
    }

    setSending(true);
    try {
      await sendToReview(data.articleId, selectedReviewers, description);
      message.success("Sent to reviewers successfully!");
      setSelectedReviewers([]);
      setRefreshTable(prev => !prev);
    } catch (err) {
      console.error(err);
      message.error('Something went wrong!');
    } finally {
      setSending(false);
    }
  };
  const handleYearChange = (year) => {
    setSelectedYear(year);
    setSelectedIssue(null); // ریست کردن ایشو انتخاب شده
    loadIssues(year); // لود ایشوها برای سال انتخابی
  };
  // بارگذاری لیست داوران برای Dropdown
  const loadReviewers = async () => {
    try {
      setReviewersLoading(true);
      const response = await getReviewerList(data.journalId);
      setReviewers(response.data);
    } catch (err) {
      message.error("Error Loading Reviewers");
      console.error(err);
    } finally {
      setReviewersLoading(false);
    }
  };

  // بارگذاری لیست ایشوها برای Dropdown
  const loadIssues = async (year) => {
    try {
      setIssuesLoading(true);
      const response = await getIssuesList(data.journalId, year)
      if (response) {
        setIssuesList(response.data);
      } else {
        setIssuesList([]);
      }
    } catch (err) {
      message.error("Error Loading Issues");
      console.error(err);
    } finally {
      setIssuesLoading(false);
    }
  };

  // انجام اکشن‌های روی مقاله
  const handleAction = async (action) => {
    setLoadingActions((prev) => ({ ...prev, [action.url]: true }));
    try {
      const response = await cartableAction(data.articleId, action.url, description);

      if (response.message && (response.message.includes('success') || response.message.toLowerCase().includes('successfully'))) {
        message.success(`${action.name} done successfully`);

        if (cartableRef?.current) {
          cartableRef.current.refresh();
        }

        setTimeout(() => {
          navigate('/admin/cartable');
        }, 1500);
      } else {
        message.error('Failed to perform action');
      }
    } catch (err) {
      console.error(err);
      message.error('Something went wrong!');
    } finally {
      setLoadingActions((prev) => ({ ...prev, [action.url]: false }));
    }
  };

  // حذف تگ‌های HTML
  function stripHtml(html) {
    return html.replace(/<[^>]+>/g, '');
  }

  // دیکد کردن HTML entities
  function decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  // گرفتن اطلاعات جدول داوران
  const fetchReviewersTable = async () => {
    try {
      const response = await getArticleStepReviewer(data?.articleId);
      const mappedData = response?.data?.map((item, index) => ({
        key: item?.id || index,
        firstName: item?.firstName,
        lastName: item?.lastName,
        email: item?.email,
        status: item?.status,
        requestAccepted: item?.reviewerAccepted != null ? (item?.reviewerAccepted == true ? <CheckOutlined style={{ color: "green", fontSize: 22, fontWeight: 'bolder' }} /> : <CloseOutlined style={{ color: "red", fontSize: 22, fontWeight: 'bolder' }} />) : <EllipsisOutlined style={{ color: "#22aad5", fontSize: 22, fontWeight: 'bolder' }} />,
        articleAccepted: item?.articleAccepted != null ? (item?.articleAccepted == true ? <CheckOutlined style={{ color: "green", fontSize: 22, fontWeight: 'bolder' }} /> : <CloseOutlined style={{ color: "red", fontSize: 22, fontWeight: 'bolder' }} />) : <EllipsisOutlined style={{ color: "#22aad5", fontSize: 22, fontWeight: 'bolder' }} />,
        articleRevised: item?.articleRevised != null ? (item?.articleRevised == true ? <CheckOutlined style={{ color: "rgb(240, 210, 40)", fontSize: 22, fontWeight: 'bolder' }} /> : <CloseOutlined style={{ color: "red", fontSize: 22, fontWeight: 'bolder' }} />) : <EllipsisOutlined style={{ color: "rgb(219 140 39)", fontSize: 22, fontWeight: 'bolder' }} />,
        doDate: item?.dodate ? item?.dodate.split('T')[0] : null,
        createDate: item?.createDate ? item?.createDate.split('T')[0] : null,
        comment: item?.comment,
        commentForAuthor: item?.commentForAuthor,
        action: item?.action,
        articleId: data?.articleId,
        reviewerId: item?.reviewerId,
      }));
      setTableData(mappedData);
    } catch (error) {
      message.error('خطا در دریافت اطلاعات جدول');
      console.error(error);
    }
  };

  useEffect(() => {
    if (data.statusTitle === "Evaluation") {
      fetchReviewersTable();
    }
  }, [refreshTable]);

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <>
      <Descriptions
        className="custom-descriptions"
        bordered
        column={1}
        size="middle"
        labelStyle={{ width: '120px', fontWeight: 'bold' }}
      >
        <Descriptions.Item label="Article Title">
          <span style={{ marginRight: '16px' }}>
            {stripHtml(decodeHtml(checkData(data.articleTitle)))}
          </span>
          <Button type="primary" size="small" onClick={() => showModal({ title: 'Article Details', type: "articleDetails" })} style={{ borderColor: '#333' }}>
            View Article Details
          </Button>
          <Button type="primary" size="small" onClick={() => showModal({ title: 'History', type: "articleHistory" })} style={{ borderColor: '#333', marginLeft: '10px' }}>
            View History
          </Button>
        </Descriptions.Item>
        <Descriptions.Item label="Code">{checkData(data.articleCode)}</Descriptions.Item>
        <Descriptions.Item label="Journal">{checkData(data.journalName)}</Descriptions.Item>
        <Descriptions.Item label="Sender">{checkData(data.authorName)}</Descriptions.Item>
        <Descriptions.Item label="Role">{checkData(data.role)}</Descriptions.Item>
        <Descriptions.Item label="Status">{checkData(data.statusTitle)}</Descriptions.Item>
        <Descriptions.Item label="Comment">{checkData(<span style={{ color: 'blue' }}>{checkData(data.comment)}</span>)}</Descriptions.Item>
        <Descriptions.Item label="Created Date">
          {checkData(data.createdDate)?.split("T")[0]}
        </Descriptions.Item>

        {/* show pdf file in ready to Publish status */}
        {data.statusTitle === "Ready To Publish" && (
          <Descriptions.Item label="Pdf File">
            {data.publishedPDFFile
              ? (
                <>
                  <FilePdfOutlined style={{ fontSize: 20, color: '#e53935', marginRight: '5px' }} />
                  <span>{data.publishedPDFFileName}</span>
                  <Button
                    size="small"
                    type="primary"
                    style={{ marginLeft: '20px' }}
                    onClick={handleViewFile}
                  >
                    View File
                  </Button>
                </>
              )
              : (
                <span style={{ color: 'gray' }}>No PDF file</span>
              )}
          </Descriptions.Item>
        )}


      </Descriptions>

      {data.statusTitle === "Evaluation" && (
        <Card
          title="Select Reviewers"
          style={{
            marginTop: '24px',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '1px solid #f0f0f0'
          }}
          headStyle={{ fontSize: '16px', color: '#333' }}
        >
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
            <Select
              className="custom-select"
              mode="multiple"
              maxTagCount={3}
              style={{
                minWidth: '300px',
                flex: 1,
                backgroundColor: '#f0f5ff',
                borderRadius: '8px',
                border: '1px solid #91caff',
                padding: '4px 8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
              }}
              placeholder="Select reviewers"
              onChange={handleReviewerChange}
              value={selectedReviewers}
              loading={reviewersLoading}
              onDropdownVisibleChange={(open) => {
                if (open && reviewers.length === 0) {
                  loadReviewers();
                }
              }}
              options={reviewers.map((r) => ({
                label: `${r?.firstName} ${r?.lastName}`,
                value: r?.reviewerId,
              }))}
              notFoundContent={reviewersLoading ? 'Loading reviewers...' : 'No reviewers found'}
            />

            <Button
              type="primary"
              loading={sending}
              onClick={handleSendToReview}
              style={{
                backgroundColor: '#1890ff',
                color: 'white',
                borderColor: '#1890ff',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(24, 144, 255, 0.6)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Send to Review
            </Button>
          </div>

          <Table
            columns={[
              { title: 'First Name', dataIndex: 'firstName', key: 'firstName' },
              { title: 'Last Name', dataIndex: 'lastName', key: 'lastName' },
              { title: 'Email', dataIndex: 'email', key: 'email' },
              { title: 'Status', dataIndex: 'status', key: 'status' },
              { title: 'Request Confirmed', dataIndex: 'requestAccepted', key: 'requestAccepted', align: 'Center' },
              { title: 'Article Accepted', dataIndex: 'articleAccepted', key: 'articleAccepted', align: 'Center' },
              { title: 'Article Revised', dataIndex: 'articleRevised', key: 'articleRevised', align: 'Center' },
              { title: 'Create Date', dataIndex: 'createDate', key: 'createDate' },
              { title: 'Do Date', dataIndex: 'doDate', key: 'doDate' },
              {
                title: 'Comment',
                dataIndex: 'comment',
                key: 'comment',
                render: (text) => (
                  <Tooltip title={text}>
                    {truncateText(text)}
                  </Tooltip>
                ),
              },
              {
                title: 'Comment For Author',
                dataIndex: 'commentForAuthor',
                key: 'commentForAuthor',
                render: (text) => (
                  <Tooltip title={text}>
                    {truncateText(text)}
                  </Tooltip>
                ),
              },
              {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
                render: (_, record) => (
                  record.doDate === null || record.doDate === undefined ? (
                    <Popconfirm
                      title="Are you sure you want to delete this reviewer?"
                      onConfirm={() => handleDelete(record)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        type="primary"
                        danger
                        shape="circle"
                        icon={<DeleteOutlined />}
                      />
                    </Popconfirm>
                  ) : null
                )
              }
            ]}
            dataSource={tableData}
            pagination={{ pageSize: 5 }}
            rowKey="key"
            style={{ marginTop: '24px' }}
          />
        </Card>
      )}

      {data.statusTitle === "Ready To Publish" && (
        <Card
          title="Select Issues"
          style={{
            marginTop: '24px',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '1px solid #f0f0f0'
          }}
          headStyle={{ fontSize: '16px', color: '#333' }}
        >
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label style={{ marginBottom: 4, fontWeight: 500 }}>Year</label>
              <Select
                style={{ width: 200 }}
                value={selectedYear}
                onChange={handleYearChange}
              >
                {years.map(year => (
                  <Option key={year} value={year}>{year}</Option>
                ))}
              </Select>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 200 }}>
              <label style={{ marginBottom: 4, fontWeight: 500 }}>Issue</label>
              <Select
                placeholder="Select issue"
                value={selectedIssue}
                onChange={setSelectedIssue}
                loading={IssuesLoading}

                onDropdownVisibleChange={(open) => {
                  if (open) {
                    loadIssues(selectedYear)
                  }
                }}
                options={issuesList.map(issue => ({
                  label: issue.title,
                  value: issue.id,
                }))}
                allowClear
              />


            </div>
          </div>
        </Card>
      )}

      {data.statusId === 8 && (
        <Card
          title="Upload PDF File for Publish"
          style={{
            marginTop: '24px',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '1px solid #f0f0f0'
          }}
          headStyle={{ fontSize: '16px', color: '#333' }}
        >

          {

            data.publishedPDFEditedFile !== null && data.publishedPDFEditedFile !== undefined ?
              <>
                <b>Download Author Edited: </b> <a download style={{ color: 'blue' }} href={'data:application/pdf;base64,' + data.publishedPDFEditedFile}>Download</a>
              </>
              : ""
          }
          <br />
          {
            data.publishedPDFFile !== null && data.publishedPDFFile !== undefined ?
              <>
                <b>Download Proofreading: </b> <a download style={{ color: 'blue' }} href={'data:application/pdf;base64,' + data.publishedPDFFile}>{data.publishedPDFFileName}</a> (Page Count: <span style={{ color: 'green' }}>{data.publishedPDFPageCount}</span>)
              </>
              : ""
          }

          <br />
          <br />

          <PdfUploader articleId={data.articleId} />

        </Card>

      )}

      {/* Description input */}
      <div style={{ marginTop: '32px', borderRadius: '8px' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '18px', color: '#333' }}>Description</h3>
        <TextArea
          value={description}
          onChange={handleDescriptionChange}
          placeholder="Write something..."
          rows={4}
          style={{
            borderRadius: '8px',
            border: '1px solid #d9d9d9',
            padding: '10px',
            fontSize: '14px',
            color: '#555',
            transition: 'all 0.3s ease',
          }}
        />
      </div>

      {/* Action Buttons */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '24px',
          marginTop: '32px',
          flexWrap: 'wrap',
        }}
      >
        {Array.isArray(data.actions) &&
          data.actions.map((action, index) => {
            const actionName = action.name.toLowerCase();

            let bgColor = '#1890ff'; // پیش‌فرض آبی
            let boxShadowColor = 'rgba(24, 144, 255, 0.6)';

            if (actionName.includes('reject')) {
              bgColor = '#ff4d4f'; // قرمز
              boxShadowColor = 'rgba(255, 77, 79, 0.6)';
            } else if (actionName.includes('publish')) {
              bgColor = '#52c41a'; // سبز
              boxShadowColor = 'rgba(82, 196, 26, 0.6)';
            } else if (actionName.includes('edit') && !actionName.includes('editor')) {
              bgColor = '#faad14'; // زرد
              boxShadowColor = 'rgba(250, 173, 20, 0.6)';
            }

            return (
              <Popconfirm
                key={index}
                title={`Are you sure you want to ${actionName} this article?`}
                onConfirm={() => handleAction(action)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="primary"
                  loading={!!loadingActions[action.url]}
                  disabled={!!loadingActions[action.url]}
                  style={{
                    backgroundColor: bgColor,
                    color: 'white',
                    borderColor: bgColor,
                    transition: 'all 0.3s ease',
                    minWidth: '200px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = `0 4px 15px ${boxShadowColor}`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  {action.name}
                </Button>
              </Popconfirm>
            );
          })}

      </div>


      {/* Modal for Article */}
      <Modal
        //title="Article Details"
        title={modalParams.title}

        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width="80%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
        centered
      >
        <ArticleModal articleId={data.articleId} type={modalParams.type} />
      </Modal>
    </>
  );
};

export default ArticleActionsDetail;
